import EventsApi from '../../Api/EventsApi'
import moment from 'moment'

export function executeGroupSearch(options) {
  return new Promise((resolve, reject) => {
    return new EventsApi().getGroupSearch(options).then(res => resolve(res)).catch(err => reject(err))
  })
}

export function getParentGroupSettings(options) {
  return new Promise((resolve, reject) => {
    return new EventsApi().getParentGroupSettings(options).then(res => resolve(res)).catch(err => reject(err))
  })
}

export function updateParentGroupSettings(options) {
  return new Promise((resolve, reject) => {
    return new EventsApi().updateParentGroupSettings(options).then(res => resolve(res)).catch(err => reject(err))
  })
}

export function getEventType(type, eventTypes) {
  return eventTypes.filter((eventType) => {
    return eventType.id === type
  })[0]
}

export function getEventDetailItem(property, eventDetails) {
  if (Array.isArray(eventDetails)) {
    const event = eventDetails.filter((eventDetail) => eventDetail.id === property)
    if (event.length) return event[0]
    else if (event) return event
    else return { value: null }
  } else {
    return eventDetails
  }
}

function setPayloadValues(userSelections) {
  return {
    eventLocationId: userSelections.location.locationId ? userSelections.location.locationId : Math.floor(Math.random() * 10),
    requestBenefitInd: getEventType('benefit', userSelections.eventTypes) && getEventType('benefit', userSelections.eventTypes).selected,
    requestDigitalInd: getEventType('digital', userSelections.eventTypes).selected,
    requestMaterialsInd: getEventType('printed', userSelections.eventTypes).selected,
    requestStandardInd: getEventType('rep', userSelections.eventTypes).selected,
    eventType: getEventDetailItem('eventType', userSelections.eventDetails).value,
    representativeType: getEventDetailItem('repType', userSelections.eventDetails).value,
    supportType: getEventDetailItem('supportType', userSelections.eventDetails).value,
    supportDetails: getEventDetailItem('supportDetails', userSelections.eventDetails).value,
    exchangeType: getEventDetailItem('exchangeType', userSelections.eventDetails).value,
    eventStartDate:
      getEventDetailItem('eventDate', userSelections.eventDetails).value
        ? getEventDetailItem('eventDate', userSelections.eventDetails).value
        : getEventDetailItem('deliverBy', userSelections.eventDetails).value,
    eventEndDate: getEventDetailItem('eventDate', userSelections.eventDetails).value,
    contactName: getEventDetailItem('customerName', userSelections.eventDetails).value,
    contactEmail: getEventDetailItem('contactEmail', userSelections.eventDetails).value,
    contactName2: getEventDetailItem('contactName2', userSelections.eventDetails).value,
    contactEmail2: getEventDetailItem('contactEmail2', userSelections.eventDetails).value,
    contactName3: getEventDetailItem('contactName3', userSelections.eventDetails).value,
    contactEmail3: getEventDetailItem('contactEmail3', userSelections.eventDetails).value,
    contactName4: getEventDetailItem('contactName4', userSelections.eventDetails).value,
    contactEmail4: getEventDetailItem('contactEmail4', userSelections.eventDetails).value,
    contactPhone: getEventDetailItem('contactPhone', userSelections.eventDetails).value,
    packetRequestedInd: getEventDetailItem('employeePackets', userSelections.eventDetails).value,
    packetQty: getEventDetailItem('packetQuantity', userSelections.eventDetails).value,
    spanishMatNeededInd: getEventDetailItem('spanishMatNeededInd', userSelections.eventDetails).value,
    spanishMatQty: getEventDetailItem('spanishMatQty', userSelections.eventDetails).value,
    staffedEventConfirmedInd: getEventDetailItem('eyeMedAssociate', userSelections.eventDetails).value,
    staffedEventAssocName: getEventDetailItem('eyeMedAssociateName', userSelections.eventDetails).value,
    presentationInd: getEventDetailItem('presentationNeed', userSelections.eventDetails).value,
    raffleItemInd: getEventDetailItem('raffledItem', userSelections.eventDetails).value,
    shipDeliverDate: getEventDetailItem('deliverBy', userSelections.eventDetails).value,
    startTime: getEventDetailItem('startTime', userSelections.eventDetails).value,
    endTime: getEventDetailItem('endTime', userSelections.eventDetails).value,
    shipAddress: {
      addressLine1: getEventDetailItem('shippingLine1', userSelections.eventDetails).value,
      addressLine2: getEventDetailItem('shippingLine2', userSelections.eventDetails).value,
      city: getEventDetailItem('shippingCity', userSelections.eventDetails).value,
      stateCode: getEventDetailItem('shippingState', userSelections.eventDetails).value,
      postalCode: getEventDetailItem('shippingZipCode', userSelections.eventDetails).value
    },
    shipAddrSeparateInd: getEventDetailItem('shipAddrSeparateInd', userSelections.eventDetails).value ? 'N' : 'Y'
  }
}

/*
* Need to test this. This function constructs the data for service consumption
*/
export function createOpenEnrollmentEvent(userSelections, parentGroupCk) {
  const fallbackBenefit = { // Service requires a benefit. If no benefit, use this.
    bsbsPrefix: '0',
    embePrefix: '0',
    copkPrefix: '0',
    groupCk: 42661,
    classId: '0',
    classPlanId: '0',
    planEffectiveDate: '1979-01-01'
  }

  let b = userSelections.selectProduct.length

    ? userSelections.selectProduct.map((benefit) => {
      if (benefit.selected === 'Y') {
        return {
          bsbsPrefix: benefit.bsbsPrefix,
          embePrefix: benefit.embePrefix,
          copkPrefix: benefit.copkPrefix,
          groupCk: benefit.groupCk,
          classId: benefit.classId,
          classPlanId: benefit.classPlanId,
          planEffectiveDate: moment(benefit.planEffectiveDate).format('YYYY-MM-DD')
        }
      }
    }) : [ fallbackBenefit ]

  const benefits = b.filter(benefit => {
    return benefit !== undefined
  })

  const setPayload = setPayloadValues(userSelections)

  const payload = {
    parentGroupCk: parentGroupCk,
    eventLocationId: userSelections.location.locationId ? userSelections.location.locationId : Math.floor(Math.random() * 10),
    requestBenefitInd: setPayload.requestBenefitInd ? 'Y' : 'N',
    requestDigitalInd: setPayload.requestDigitalInd ? 'Y' : 'N',
    requestMaterialsInd: setPayload.requestMaterialsInd ? 'Y' : 'N',
    requestStandardInd: setPayload.requestStandardInd ? 'Y' : 'N',
    eventType: setPayload.eventType === 'Open Enrollment' ? '2' : setPayload.presentationInd === 'Y' && setPayload.eventType !== 'Open Enrollment' ? '3' : '1',
    // NOTE: General Wellness (1), or Open Enrollment (2), or General Wellness and Presentation Needed (3)
    representativeType: setPayload.representativeType === 'Virtual Representative' ? 'Virtual' : setPayload.representativeType === 'On-Site Representative' ? 'On-site' : '',
    supportType: setPayload.representativeType === 'Virtual Representative' ? setPayload.supportType : '',
    supportDetails: setPayload.supportType === 'Other' ? setPayload.supportDetails : '',
    exchangeType: setPayload.exchangeType,
    eventStartDate: setPayload.startTime ? `${setPayload.eventStartDate}T${setPayload.startTime}:00.000Z` : setPayload.eventStartDate,
    eventEndDate: setPayload.endTime ? `${setPayload.eventEndDate}T${setPayload.endTime}:00.000Z` : setPayload.eventEndDate,
    contactName: setPayload.contactName,
    contactEmail: setPayload.contactEmail,
    contactName2: setPayload.contactName2,
    contactEmail2: setPayload.contactEmail2,
    contactName3: setPayload.contactName3,
    contactEmail3: setPayload.contactEmail3,
    contactName4: setPayload.contactName4,
    contactEmail4: setPayload.contactEmail4,
    contactPhone: setPayload.contactPhone,
    packetRequestedInd: setPayload.packetRequestedInd ? 'Y' : 'N',
    packetQty: setPayload.packetQty ? setPayload.packetQty : '0',
    spanishMatNeededInd: setPayload.spanishMatNeededInd ? 'Y' : 'N',
    spanishMatQty: setPayload.spanishMatNeededInd === 'N' ? '0' : setPayload.spanishMatQty,
    staffedEventConfirmedInd: setPayload.staffedEventConfirmedInd ? 'Y' : 'N',
    staffedEventAssocName: setPayload.staffedEventAssocName,
    presentationInd: setPayload.representativeType === 'Virtual Representative' ? 'N' : setPayload.presentationInd ? 'Y' : 'N',
    raffleItemInd: setPayload.representativeType === 'Virtual Representative' ? 'N' : setPayload.raffleItemInd ? 'Y' : 'N',
    shipDeliverDate: setPayload.shipDeliverDate ? setPayload.shipDeliverDate : setPayload.eventStartDate,
    shipAddrSeparateInd: setPayload.representativeType === 'Virtual Representative' ? 'N' : setPayload.shipAddrSeparateInd ? 'Y' : 'N',
    shipAddress: {
      addressLine1: setPayload.shipAddress.addressLine1 ? setPayload.shipAddress.addressLine1 : userSelections.location.location.addressLine1,
      addressLine2: setPayload.shipAddress.addressLine2 ? setPayload.shipAddress.addressLine2 : userSelections.location.location.addressLine2,
      city: setPayload.shipAddress.city ? setPayload.shipAddress.city : userSelections.location.location.city,
      stateCode: setPayload.shipAddress.stateCode ? setPayload.shipAddress.stateCode : userSelections.location.location.state,
      postalCode: setPayload.shipAddress.postalCode ? setPayload.shipAddress.postalCode : userSelections.location.location.zipCode
    },
    benefits: benefits.length ? benefits : [ fallbackBenefit ]
  }

  return new Promise((resolve, reject) => {
    new EventsApi().createEventRequest(payload).then(res => resolve(res)).catch(err => reject(err))
  })
}

export function updateLocation(options) {
  return new Promise((resolve, reject) => {
    new EventsApi().updateEventLocation(options).then(res => resolve(res)).catch(err => reject(err))
  })
}

export function getParentGroupProductKeys(options) {
  return new Promise((resolve, reject) => {
    new EventsApi().getParentGroupProductKeys(options).then(res => resolve(res)).catch(err => reject(err))
  })
}
